import { render, staticRenderFns } from "./PriceControlEdit.vue?vue&type=template&id=508572da&scoped=true"
import script from "./PriceControlEdit.vue?vue&type=script&lang=js"
export * from "./PriceControlEdit.vue?vue&type=script&lang=js"
import style0 from "./PriceControlEdit.vue?vue&type=style&index=0&id=508572da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508572da",
  null
  
)

export default component.exports